import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChatPanelComponent } from 'app/layout/components/chat-panel/chat-panel.component';
import { ChatPanelService } from 'app/layout/components/chat-panel/chat-panel.service';
import { SelectGroupMembersDialogModule } from 'app/library/group/components/dialogs/select-group-members-dialog/select-group-members.dialog.module';
import { MaxBrainSharedModule } from 'app/projects/shared/src/lib/shared.module';

@NgModule({
    declarations: [ChatPanelComponent],
    providers: [ChatPanelService],
    imports: [
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatTabsModule,
        MatTooltipModule,
        MatRippleModule,
        SelectGroupMembersDialogModule,
        MaxBrainSharedModule,
    ],
    exports: [ChatPanelComponent],
})
export class ChatPanelModule {}
